exports = module.exports = require("../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".recordcard-head-image{border:2px solid rgba(0,161,176,.5);border-radius:3.25vh;width:6.5vh;height:6.5vh}.recordcard-player-button{background-color:#3890ae;border-radius:23px;border-width:0;display:flex;align-items:center;padding:3px 12px 3px 5px;justify-content:space-between}.recordcard-play-button{margin-right:18px;height:4.5vh!important}.recordcard-player-img{height:4vh}.recordcard-refresh-button{position:absolute;top:4px;right:4px;font-family:PingFangSC-Regular;font-size:14px;color:#00a1b0}", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./~/css-loader!./src/routes/Home/components/RecordCard/RecordCard.css
// module id = 345
// module chunks = 5